import { Box } from '@branch-messenger/willow-ui'
import { useSuspenseQuery } from '@tanstack/react-query'

import {
  SidebarHeader,
  SidebarMenuDesktop,
  SidebarMenuMobile,
} from '@/components/sidebar'
import { paymentProfileQueryOptions } from '@/queries/profile'

import { DirectCardInfo } from './DirectCardInfo'
import { useSidebarMenuItems } from './hooks/useSidebarMenuItems'
import { NoPayoutMethod } from './NoPayoutMethod'
import { PayoutSidebarContainer } from './styles'
import { WalletInfo } from './WalletInfo'

export const SidebarContent = () => {
  const {
    data: { active_type },
  } = useSuspenseQuery(paymentProfileQueryOptions)
  const sidebarMenuItems = useSidebarMenuItems()?.[active_type]

  return (
    <PayoutSidebarContainer>
      <Box $display="flex" $justify="space-between" $gap={1}>
        <SidebarHeader>Payment method</SidebarHeader>
        {sidebarMenuItems && <SidebarMenuMobile menuItems={sidebarMenuItems} />}
      </Box>

      {active_type === 'CARD' && <DirectCardInfo />}
      {active_type === 'WALLET' && <WalletInfo />}
      {active_type === 'NONE' && <NoPayoutMethod />}
      {sidebarMenuItems && <SidebarMenuDesktop menuItems={sidebarMenuItems} />}
    </PayoutSidebarContainer>
  )
}
